// 存放 Vue mixin 可混入的代码
/*
使用说明
接收到数据时，调用了一个离开页面的方法
self.leavePage(obj); //调用离开页面方法;
**/
'use strict'
export const mixinSocketIO = {
  data() {
    return {
      socket: null,
      connected:null,
      wsUrl: '',
      // uuid: null,
      distinguishVal: false,
      firstConnect: false, //第一次连接
      runResult: null,
    }
  },
  computed: {},
  mounted() {
    // this.uuid = this.$util.generateUUID()
  },
  destroyed() {
    if (this.socket) {
      this.socketDisconnect()
      this.socketClose()
      this.socket = null
    }
  },
  methods: {
    // 初始化-链接socket
    socketConnect(wsUrl) {
      if (!this.socket || !this.connected) {
        let _this = this

        //链接socket
        this.socket = window.io.connect(`${wsUrl}`)
        //客户端监听是否链接成功
        this.socket.on('connect', function(msg) {
          if (msg) {
            this.connected = true
            console.log('connect msg：', msg)
            if (msg['status']) {
              console.log('socket链接监听：', msg['data'])
            }
          }
          // let data = { uuid: _this.uuid }
          // _this.socketSend(data)
          _this.onSocket()
          _this.onDisconnect()
        })
      }
    },


    //监听socket返回信息
    onSocket() {
      let _this = this
      let data = 'data_response'
      this.socket.off(data)
      this.socket.on(data, function(msg) {
        if (msg) {
          _this.socketInfoHandler(msg)
        }
      })
    },
    socketDisconnect(){
      try {
        this.socket.disconnect()
      } catch (e) {
        // console.log()
      }
    },
    onDisconnect(){
      let _this = this
      let data = 'disconnect'
      this.socket.off(data)
      this.socket.on(data, function(msg) {
        if (msg&& msg.data =='Disconnected') {
          _this.connected =false
        }
      })
    },
    //客户端发送信息给服务器
    socketSend(data) {
      this.socket.emit('get_data', data)
    },

    //客户端发送信息给服务器
    socketRun(data) {
      this.socket.emit('run', data)
    },
    //处理socket
    socketClose() {
      // try {
        this.socket.close()
      // } catch (e) {
      //   console.log()
      // }
    },
    socketInfoHandler(msg) {
      console.log('msg',msg)
      if (msg) {
        this.runResult = msg.data
        if (msg.status) {
          //运行正确的信息
          this.runResultHandle(msg.data)
        } else {
          //运行失败的信息
          console.log('error----')
            this.errorMsgHandle(msg.error_msg)
        }
      }
    },
    // createWebSocket(wsUrl) {
    //   let self = this
    //   if (wsUrl) {
    //     this.wsUrl = wsUrl
    //   } else {
    //     wsUrl = this.wsUrl
    //   }
    //   // 与websocket服务器创建连接
    //   let websocket = new WebSocket(wsUrl)
    //   // 连接成功时
    //   websocket.onopen = () => {
    //     websocket.send('hello')
    //     console.log('websocket is ok')
    //   }
    //   websocket.onmessage = (event) => {
    //     // 后端发送的消息在event.data中
    //     if (event.data && event.data !== 'hello' && event.data !== '连接成功') {
    //       let str = event.data
    //       try {
    //         let obj = JSON.parse(str)
    //         if (typeof obj !== 'object') return
    //         self.leavePage(obj) //调用离开页面方法;
    //       } catch (e) {
    //         console.log(e)
    //       }
    //     }
    //   }
    //   websocket.onclose = function() {
    //     console.log('关闭了')
    //   }
    //   // 路由跳转时结束websocket链接
    //   this.$router.afterEach(function() {
    //     websocket.close()
    //   })
    // },
  },
}
